/**
 * Shared canvas height for GHG inventory Chart.js charts (inventory comparison, sectors, etc.).
 * Used as both `height` and `minHeight` on chart wrapper divs.
 */
export const GHG_INVENTORY_CHART_HEIGHT_PX = 420;

/** Taller canvas for line/stacked charts so the HTML legend stays readable on mobile. */
export const GHG_INVENTORY_TIME_SERIES_CANVAS_HEIGHT_PX = 360;

/** Total wrapper height including flex-wrapped HTML legend and safe-area padding. */
export const GHG_INVENTORY_TIME_SERIES_TOTAL_HEIGHT_PX = 520;
